import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable } from 'knockout';
import WCCAttachment from 'models/attachments/attachment';
import WCCAudio from 'models/attachments/audio';
import WCCFile from 'models/attachments/file';
import WCCImage from 'models/attachments/image';
import WCCVideo from 'models/attachments/video';
import WCCVimeoVideo from 'models/attachments/vimeo';
import WCCYoutubeVideo from 'models/attachments/youtube';
import WCCUpload from 'models/upload';
import './generic.html';

components.preload('wcc-upload', 'wcc-image', 'wcc-video', 'wcc-file', 'wcc-youtube-video', 'wcc-vimeo-video', 'wcc-audio');

@injectable()
export default class WCCGenericAttachmentVM {
    templateNodes: Subscribable<Array<Node>>

    constructor(
        @inject(wccModules.componentConfig) public attachment: WCCAttachment,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.templateNodes = ko.pureComputed(() => this.getTemplateNodes(attachment, info.templateNodes));
    }

    private getTemplateNodes(attachment: WCCAttachment, nodes: Array<Node>) {
        if (attachment instanceof WCCUpload)
            return this.getNodes(nodes, 'upload-tpl', '<wcc-upload params="upload: $data"></wcc-upload>');
        else if (attachment instanceof WCCImage)
            return this.getNodes(nodes, 'image-tpl', '<wcc-image params="image: $data"></wcc-image>');
        else if (attachment instanceof WCCVideo)
            return this.getNodes(nodes, 'video-tpl', '<wcc-video params="model: $data"></wcc-video>');
        else if (attachment instanceof WCCAudio)
            return this.getNodes(nodes, 'audio-tpl', '<wcc-audio params="audio: $data"></wcc-audio>');
        else if (attachment instanceof WCCFile)
            return this.getNodes(nodes, 'file-tpl', '<wcc-file params="model: $data"></wcc-file>');
        else if (attachment instanceof WCCYoutubeVideo)
            return this.getNodes(nodes, 'youtube-tpl', '<wcc-youtube-video params="video: $data" />');
        else if (attachment instanceof WCCVimeoVideo)
            return this.getNodes(nodes, 'vimeo-tpl', '<wcc-vimeo-video params="video: $data" />');
        else
            return [];
    }

    private getNodes(nodes: Array<Node>, selector: string, defaultNodes: Array<Node> | string): Array<Node> {
        let result = $(nodes).filter(selector).contents().toArray() as Array<Node>;

        if (result.length == 0)
            return _.isString(defaultNodes) ? $(defaultNodes).toArray() : defaultNodes;

        return result;
    }
}